export const botBuilderKeys = {
	bots: ["bot-builder", "bots"] as const,
	archivedBots: ["bot-builder", "bots", "archived"] as const,
	helperBots: ["bot-builder", "bots", "helpers"] as const,
	bot: (id: string) => ["bot-builder", "bot", id] as const,
	payments: (id: string) => ["bot-builder", "payments", id] as const,
	scenarios: ["bot-builder", "scenarios"] as const,
	scenario: (id: string) => ["bot-builder", "scenario", id] as const,
	testChat: (id: string) => ["bot-builder", "test-chat", id] as const,
	versions: (id: string) => ["bot-builder", "versions", id] as const,
	chats: (id: string) => ["bot-builder", "chats", id] as const,
}

export const scenarioPath = (id: string, path = "") => `/admin/bot-scenarios/${id}${path}`

export type Revised<T> = T & { revision: number }
